import { z } from 'zod';
import {
    OVERTIME_COMPENSATION_TYPES,
    OVERTIME_MAX_CLIENT_EMAILS,
    OVERTIME_MAX_REASON,
    OVERTIME_MIN_REASON,
    isRaroManagerEmail,
    overtimeDurationMinutes,
} from '../../../../shared/dpRequests';

export const overtimeFormSchema = z
    .object({
        projectName: z.string().trim().min(1, 'Informe o projeto em que você atua').max(120, 'O projeto pode ter no máximo 120 caracteres'),
        internalProject: z.boolean(),
        clientManagerEmails: z
            .array(z.string().trim().email('Um dos e-mails do cliente é inválido'))
            .max(OVERTIME_MAX_CLIENT_EMAILS, `Informe no máximo ${OVERTIME_MAX_CLIENT_EMAILS} e-mails`),
        raroManagerEmail: z
            .string()
            .trim()
            .refine(isRaroManagerEmail, 'Escolha o gestor Raro Labs (e-mail @rarolabs.com.br)'),
        date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Informe a data da hora extra'),
        startTime: z.string().regex(/^\d{2}:\d{2}$/, 'Informe a hora de início'),
        endTime: z.string().regex(/^\d{2}:\d{2}$/, 'Informe a hora de término'),
        reason: z
            .string()
            .trim()
            .min(OVERTIME_MIN_REASON, `Explique o motivo com pelo menos ${OVERTIME_MIN_REASON} caracteres`)
            .max(OVERTIME_MAX_REASON, `O motivo pode ter no máximo ${OVERTIME_MAX_REASON} caracteres`),
        compensationType: z.enum(OVERTIME_COMPENSATION_TYPES, { errorMap: () => ({ message: 'Escolha compensação ou pagamento' }) }),
    })
    .superRefine((value, context) => {
        if (!value.internalProject && value.clientManagerEmails.length === 0) {
            context.addIssue({
                code: z.ZodIssueCode.custom,
                path: ['clientManagerEmails'],
                message: 'Informe o e-mail do gestor do cliente ou marque projeto interno',
            });
        }
        if (/^\d{2}:\d{2}$/.test(value.startTime) && /^\d{2}:\d{2}$/.test(value.endTime) && overtimeDurationMinutes(value.startTime, value.endTime) === null) {
            context.addIssue({ code: z.ZodIssueCode.custom, path: ['endTime'], message: 'A hora de término deve ser depois da hora de início' });
        }
    });

export type OvertimeFormValues = z.infer<typeof overtimeFormSchema>;
